export const utilizationPatientPageMessages = {
  PATIENT_UTILIZATION_PAGE: {
    TITLE: 'Admission Utilization',
    SUBTITLE:
      'Metrics on medical claims from plan members experiencing hospital admissions.',
    ADMISSION_FLAGS: ['Inpatient', 'Emergency'],
    COHORT_DETAILS: {
      TITLE: 'Cohort Details',
      SUBTITLE:
        'Select the properties that you would like to apply to current data',
    },
    PATIENT_UTILIZATION_CARDS: {
      MEMBERS: 'Members',
      TOTAL_COST: 'Total Cost',
      TOTAL_MEDICAL_COST: 'Total Medical Cost',
      PMPM: 'PMPM',
      PEPM: 'PEPM',
      PATIENT_ADMISSION: {
        TITLE: (selectedFlag: string) => `${selectedFlag} Admission Cost`,
        SUB_TITLE:
          'This visual shows the cost trend of inpatient admission category for the selected period',
      },
      TOP_PATIENT_PROVIDERS: {
        TITLE: (selectedFlag: string) => `Top ${selectedFlag} Providers`,
        SUB_TITLE: {
          PART1: 'These are the top ',
          PART2: ' providers',
        },
        DROPDOWN_OPTIONS: [
          'In Patient',
          'Emergency',
          'Out Patient',
          'Urgent Care',
        ],
        DROPDOWN_DISPLAYS: [
          'Inpatient',
          'Emergency',
          'Outpatient',
          'Urgent Care',
        ],
      },
      NO_OF_ADMISSIONS: {
        TITLE: (selectedFlag: string) => `${selectedFlag} Admissions`,
        AXIS_LABELS: {
          X_AXIS: 'Year',
          Y_AXIS: 'Admits',
        },
      },
      READMISSION_RATE: {
        TITLE: (selectedFlag: string) =>
          `${selectedFlag} Days per 1000 Members`,
        AXIS_LABELS: {
          X_AXIS: 'Year',
          Y_AXIS: 'Days',
        },
      },
      INPATIENT_STAY: {
        TITLE: (selectedFlag: string) => `Avg Length of ${selectedFlag} Stay`,
        AXIS_LABELS: {
          X_AXIS: 'Year',
          Y_AXIS: 'Days',
        },
      },
    },
  },
};
